/**
 * ATT-2872 — derive a low-cardinality, no-PII tenant slug from a normalized
 * hostname, for use as a Sentry tag.
 *
 * Rule: strip a leading `admin.` segment, then take the first label that
 * remains. Examples:
 *   - `admin.demo.attendly.com`               → "demo"
 *   - `admin.meetenrich.com`                  → "meetenrich"
 *   - `admin.expanded-learning-sausd.us`      → "expanded-learning-sausd"
 *   - `localhost`                             → "local"
 *
 * Returns `null` when the host is empty (so the caller can skip the tag).
 *
 * Cardinality budget: bounded by the number of tenants × deployment
 * environments. Roughly < 100 distinct values in steady state.
 */
export function deriveTenantSlugFromHost(host: string): string | null {
  const trimmed = host.trim().toLowerCase();
  if (!trimmed) return null;
  if (trimmed === "localhost") return "local";
  const withoutAdmin = trimmed.startsWith("admin.") ? trimmed.slice("admin.".length) : trimmed;
  const firstLabel = withoutAdmin.split(".")[0];
  return firstLabel || null;
}
